// Core Modules
import { Component, inject } from '@angular/core';

// External Modules
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-unsaved-audience-confirm-modal',
  standalone: true,
  imports: [],
  templateUrl: './unsaved-audience-confirm-modal.component.html',
  styleUrl: './unsaved-audience-confirm-modal.component.scss',
})
export class UnsavedAudienceConfirmModalComponent {
  // Injectors
  private readonly ngbActiveModal = inject(NgbActiveModal);

  public confirm(): void {
    this.ngbActiveModal.close({ status: 'success' });
  }

  public dismissModal(reason: string): void {
    this.ngbActiveModal.dismiss(reason);
  }
}
